import { Lightning } from '@lightningjs/sdk'
import { loadBrands } from '../lib/api/Api'
import ArrowButton from './buttons/ArrowButton'
import MenuCarousel from './carousel/MenuCarousel'
import StationCover from './coverItems/StationCover'

export default class TopMenu extends Lightning.Component {
  static _template() {
    return {
      w: 1081,
      h: 180,
      x: 500,
      y: 72,
      zIndex: 100,
      alpha: 0.001,
      scale: 0.7,
      LeftArrow: { x: 0, y: 57, w: 46, h: 46, type: ArrowButton, buttonType: 'left' },
      Fader: {
        x: 45,
        y: 0,
        w: 990,
        h: 180,
        rtt: true,
        shader: { type: Lightning.shaders.FadeOut, right: 40, left: 40 },
        MenuCarousel: {
          x: 40,
          w: 1675,
          h: 160,
          type: MenuCarousel,
          spacing: 30,
          visibleCells: 5,
          signals: { onIndexChanged: true, menuBuild: true },
        },
      },
      RightArrow: { x: 1035, y: 57, w: 46, h: 46, type: ArrowButton, buttonType: 'right' },
    }
  }

  set brand({ index, brandName }) {
    this._dataIndex = index
    this._brandName = brandName
    loadBrands().then(brandsData => {
      this._stationBrands = brandsData.brands

      this.meniItems = this._stationBrands.map((mnuItem, idx) => {
        mnuItem.dataIndex = idx
        return {
          ref: `Mnu-${mnuItem.name}`,
          h: 85,
          w: 85,
          type: StationCover,
          dims: { wd: 85, hg: 85, padding: 41 },
          item: mnuItem,
          dataIndex: idx,
        }
      })

      this.tag('MenuCarousel').data = {
        items: this.meniItems,
        data: this._stationBrands,
        index: this._dataIndex,
        brandName: this._brandName,
      }
    })
  }

  set navigating(bool) {
    this._navigating = bool
  }

  get activeMenuItem() {
    return this.tag('MenuCarousel').activeChild.item
  }

  menuBuild() {
    if (this.tag('MenuCarousel') && this.tag('MenuCarousel').hasItems) {
      this.setSmooth('alpha', 1)
    }
  }

  _focus() {
    this.patch({ smooth: { scale: [1, { duration: 0.3, timingFunction: 'ease-out' }] } })

    this.tag('LeftArrow')._focus()
    this.tag('RightArrow')._focus()
  }

  _unfocus() {
    if (this._navigating === false) {
      this.patch({ smooth: { scale: [0.7, { duration: 0.3, timingFunction: 'ease-in' }] } })
    }

    this.tag('LeftArrow')._unfocus()
    this.tag('RightArrow')._unfocus()
  }

  _getFocused() {
    return this.tag('MenuCarousel')
  }
}
